import { createApiSaga } from '../../../sagaGenerator';
import { apiDelete, apiGet } from '../../../../middleware/api';
import {
  MARIGRAM_DATA_DELETE_MARIGRAM_REQUEST,
  MARIGRAM_DATA_DELETE_MARIGRAM_SUCCESS,
  MARIGRAM_DATA_DELETE_MARIGRAM_FAILURE,
  MARIGRAM_DATA_COUNTRY_SUCCESS,
  MARIGRAM_DATA_COUNTRY_REQUEST,
  MARIGRAM_DATA_COUNTRY_FAILURE,
  MARIGRAM_DATA_LOCATION_SUCCESS,
  MARIGRAM_DATA_LOCATION_REQUEST,
  MARIGRAM_DATA_LOCATION_FAILURE,
  MARIGRAM_DATA_STATE_SUCCESS,
  MARIGRAM_DATA_STATE_REQUEST,
  MARIGRAM_DATA_STATE_FAILURE,
} from './marigramDataReducer';

const deleteMarigramSaga = createApiSaga({
  apiFunction: apiDelete,
  generateApiConfig: action => ({ endpoint: `/marigrams/${action.id}`, ...action }),
  requestType: MARIGRAM_DATA_DELETE_MARIGRAM_REQUEST,
  successType: MARIGRAM_DATA_DELETE_MARIGRAM_SUCCESS,
  failureType: MARIGRAM_DATA_DELETE_MARIGRAM_FAILURE,
  successMessage: 'Deleted',
});

const getCountriesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/countries', ...action }),
  requestType: MARIGRAM_DATA_COUNTRY_REQUEST,
  successType: MARIGRAM_DATA_COUNTRY_SUCCESS,
  failureType: MARIGRAM_DATA_COUNTRY_FAILURE,
});

const getLocationsSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/locations', ...action }),
  requestType: MARIGRAM_DATA_LOCATION_REQUEST,
  successType: MARIGRAM_DATA_LOCATION_SUCCESS,
  failureType: MARIGRAM_DATA_LOCATION_FAILURE,
});


const getStatesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/tsunamis/marigrams/states', ...action }),
  requestType: MARIGRAM_DATA_STATE_REQUEST,
  successType: MARIGRAM_DATA_STATE_SUCCESS,
  failureType: MARIGRAM_DATA_STATE_FAILURE,
});

export const marigramDataSagas = [
  deleteMarigramSaga,
  getCountriesSaga,
  getLocationsSaga,
  getStatesSaga,
];
